import React from "react";
import PrivateRoute from "PrivateRoutes";
import queryString from 'query-string';
import {
  WebHook,
  WebHookAddEdit,
  CTIPopup,
  CTIPopupAddEdit,
  IntegrationConfigureForm,
  IntegrationAddEdit,
  Integration,
  GuideWire,
  GuideWireAddEdit,
  SalesforceAddEdit,
  Salesforce,
  SalesforceAuth,
  Sharepoint,
  SharepointAddEdit,
  SharepointAuth,
  SnowflakeAddEdit,
  Snowflake,
} from "./components";
// import GuideWire from './components/GuideWire';
// import GuideWireAddEdit from './components/GuideWire/GuideWireAddEdit';

const salesforceLogin = ({ location, match }) => {
  const queryParams = queryString.parse(location.search);
  console.log('queryParams', queryParams, match)
  return <SalesforceAuth type={match.params.type} />;
};

const sharepointLogin = ({ location, match }) => {
  const queryParams = queryString.parse(location.search);
  console.log('queryParams', queryParams, match)
  return <SharepointAuth type={match.params.type} />;
};

const routes = () => {
  return (
    <React.Fragment>
      <PrivateRoute
        exact={true}
        path="/settings/integrations"
        component={() => <Integration />}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/:id"
        component={({ match }) => (
          <IntegrationConfigureForm id={match.params.id} />
        )}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/cti-popup/:id"
        component={({ match }) => <CTIPopup id={match.params.id} />}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/cti-popup/:id/create"
        component={({ match }) => (
          <CTIPopupAddEdit mode="create" id={match.params.id} />
        )}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/cti-popup/:ctipopupId/edit/:id"
        component={({ match }) => (
          <CTIPopupAddEdit
            mode="edit"
            ctipopupId={match.params.ctipopupId}
            id={match.params.id}
          />
        )}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/webHook/:id"
        component={({ match }) => <WebHook id={match.params.id} />}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/webHook/:id/create"
        component={({ match }) => (
          <WebHookAddEdit mode="create" id={match.params.id} />
        )}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/webHook/:webHookId/edit/:id"
        component={({ match }) => (
          <WebHookAddEdit
            mode="edit"
            id={match.params.id}
            webHookId={match.params.webHookId}
          />
        )}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/guidewire/:id"
        component={({ match }) => <GuideWire id={match.params.id} />}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/guidewire/:id/create"
        component={({ match }) => (
          <GuideWireAddEdit mode="create" id={match.params.id} />
        )}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/guidewire/:guideWireId/edit/:id"
        component={({ match }) => (
          <GuideWireAddEdit
            mode="edit"
            id={match.params.id}
            guideWireId={match.params.guideWireId}
          />
        )}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/salesforce/:id"
        component={({ match }) => <Salesforce id={match.params.id} />}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/salesforce/:id/create"
        component={({ match }) => (
          <SalesforceAddEdit mode="create" id={match.params.id} />
        )}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/salesforce/:salesdforceId/edit/:id"
        component={({ match }) => (
          <SalesforceAddEdit
            mode="edit"
            id={match.params.id}
            salesforceId={match.params.salesforceId}
          />
        )}
      />
      <PrivateRoute
        exact={true}
        path="/integration-auth/salesforce"
        component={salesforceLogin}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/sharepoint/:id"
        component={({ match }) => <Sharepoint id={match.params.id} />}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/sharepoint/:id/create"
        component={({ match }) => (
          <SharepointAddEdit mode="create" id={match.params.id} />
        )}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/sharepoint/:sharepointId/edit/:id"
        component={({ match }) => (
          <SharepointAddEdit
            mode="edit"
            id={match.params.id}
            sharepointId={match.params.sharepointId}
          />
        )}
      />
      <PrivateRoute
        exact={true}
        path="/integration-auth/sharepoint"
        component={sharepointLogin}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/snowflake/:id"
        component={({ match }) => <Snowflake id={match.params.id} />}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/snowflake/:id/create"
        component={({ match }) => (
          <SnowflakeAddEdit mode="create" id={match.params.id} />
        )}
      />
      <PrivateRoute
        exact={true}
        path="/settings/integrations/snowflake/:snowflakeId/edit/:id"
        component={({ match }) => (
          <SnowflakeAddEdit
            mode="edit"
            id={match.params.id}
            salesforceId={match.params.snowflakeId}
          />
        )}
      />
    </React.Fragment>

  );
};

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Integrations/routes.js